import React from 'react'
import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Button,
    Flex,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {remCalc} from '../../theme/_utils'
import {CheckIcon} from '../icons'
import {FormattedMessage} from 'react-intl'
import {useHistory} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const SubscriptionCancellationModal = ({isOpen, onClose, subscriptionId}) => {
    const history = useHistory()
    const {locale} = useMultiSite()
    const localeId = locale?.id?.toLowerCase()

    const handleGoToDetails = () => {
        onClose()
        history.push(`/${localeId}/account/subscription-details/${subscriptionId}`)
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent maxWidth={remCalc(451)}>
                <ModalHeader>
                    <Flex justifyContent="space-between">
                        <Flex gap={remCalc(17)} alignItems="center">
                            <CheckIcon
                                w={remCalc(24)}
                                h={remCalc(24)}
                                color="text.inverse"
                                backgroundColor="text.success"
                                borderRadius="50%"
                            />
                            <Text fontWeight="normal" textStyle="body-small" color="text.default">
                                <FormattedMessage
                                    id="subscription_cancelled_confirmation_title"
                                    defaultMessage="Subscription cancelled"
                                />
                            </Text>
                        </Flex>
                    </Flex>
                </ModalHeader>
                <ModalBody data-testid="modal-body">
                    <Text fontWeight="normal" textStyle="body-small" color="text.default">
                        <FormattedMessage
                            id="subscription_cancelled_confirmation_description"
                            defaultMessage="Your subscription has been successfully canceled. You will receive a confirmation email within 2-4 hours."
                        />
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleGoToDetails} width="100%">
                        <FormattedMessage
                            id="subscription_cancellation_confirmation_button"
                            defaultMessage="Subscription Detail"
                        />
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

SubscriptionCancellationModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    subscriptionId: PropTypes.string,
}

export default SubscriptionCancellationModal
